"use client";

import { LuArrowUpDown } from "react-icons/lu";

export type SortKey =
  | "top"
  | "reviewed"
  | "price-asc"
  | "price-desc"
  | "recent";

export const SORT_LABELS: Record<SortKey, string> = {
  top: "Top rated",
  reviewed: "Most reviewed",
  "price-asc": "Price: low → high",
  "price-desc": "Price: high → low",
  recent: "Recently active",
};

export type SortDropdownProps = {
  value: SortKey;
  onChange: (value: SortKey) => void;
  /** When true, the price-* options are hidden (used in agency-only mode
   *  where price isn't meaningful). */
  hidePriceSorts?: boolean;
};

export function SortDropdown({
  value,
  onChange,
  hidePriceSorts = false,
}: SortDropdownProps) {
  const options: SortKey[] = hidePriceSorts
    ? ["top", "reviewed", "recent"]
    : ["top", "reviewed", "price-asc", "price-desc", "recent"];

  return (
    <div className="relative">
      <LuArrowUpDown className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as SortKey)}
        aria-label="Sort by"
        className="appearance-none pl-9 pr-8 py-2 rounded-xl bg-white dark:bg-white/5 border border-gray-200 dark:border-white/10 text-sm text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent cursor-pointer"
      >
        {options.map((opt) => (
          <option key={opt} value={opt} className="bg-white dark:bg-gray-900">
            {SORT_LABELS[opt]}
          </option>
        ))}
      </select>
      {/* caret */}
      <svg
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400"
        fill="none"
        viewBox="0 0 20 20"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden="true"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 8l4 4 4-4" />
      </svg>
    </div>
  );
}
